import React, { useState } from 'react';
import { StatusEditModal } from './StatusEditModal'

export const Status = ({ order, editable, statuses = [], onStatusChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    areStatusesUniform,
    status: { name, color },
  } = order;

  const handleClick = () => {
    if(!editable || statuses.length === 0) return;

    setIsOpen(true);
  };


  const handleModalClose = () => setIsOpen(false);

  return (
    <>
      <span className="badge badge-danger cursor-pointer" style={{ backgroundColor: color }} onClick={handleClick}>
        {!areStatusesUniform && (
          <>
            <i className="bx bxs-help-circle mr-0" style={{ fontSize: '0.8rem' }} />{' '}
          </>
        )}
        {name}
      </span>
      <StatusEditModal isOpen={isOpen} onModalClose={handleModalClose} order={order} statuses={statuses} onStatusChange={onStatusChange} />
    </>
  );
};
